// extracted by mini-css-extract-plugin
module.exports = {"nonGrid":"zZ91y","cards":"EvnZp","EtimesWidget":"EF0bg","onebyoneCard":"khqlD","content":"M8hak","titlefont":"pf60w"};